import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/contacts',
        name: 'ContactsView',
        component: () => import(/* webpackChunkName: "contacts-view" */ '@/modules/contacts/components/ContactsView'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'contacts',
            preloads: ['contacts/propertyOverviewColumns']
        },
        props: true,
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/contacts/:id',
        name: 'ContactForm',
        component: () => import(/* webpackChunkName: "contacts-form" */ '@/modules/contacts/components/ContactForm'),
        meta: {
            moduleId: 'contacts',
            preloads: [
                'contacts/addresstypes', 
                'system/countries/default',
                'registryitems?keyLabel=Exchange.Synchronisation.Enabled'
            ],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
]
